import React, { Component } from 'react';

import './InformationCards.css'

class InformationCards extends Component {
    state = {}

    goToLocation = () => {
        if(this.props.document != undefined) {

            window.open(this.props.document, '_blank')
        }
    }
    render() { 
        return ( 
            <div className={"referralsCard " + this.props.hover} onClick={this.goToLocation} style={{borderTop: this.props.style}}>
                <h3 className="miniHeadings">
                    {this.props.title}
                </h3>
                <h3>
                    {this.props.body}
                    <i className={this.props.icon} style={{color: this.props.iconColor, float: "right"}}></i>
                </h3>
                <br/>
            </div>
         )
    }
}
 

export default InformationCards;


// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/InformationCards/InformationCards.jsx